import { z } from "zod";

export function createSchema(length: string, unique: string) {
  const value = z.string().regex(/^\d{13}$/, { error: length });

  const schema = z.object({
    values: z.array(z.object({ value })),
  });

  return schema.superRefine((data, context) => {
    const items = data.values.map((v) => v.value);
    const seen = new Set<string>();

    items.forEach((item, index) => {
      if (!item) {
        return;
      }
      if (!seen.has(item)) {
        seen.add(item);
        return;
      }

      context.issues.push({
        path: ["values", index, "value"],
        message: unique,
        code: "custom",
        input: context.value.values[index].value,
      });
    });
  });
}
